import { StateEffect } from "@codemirror/state";
import { StateField } from "@codemirror/state";
import { ViewPlugin } from "@codemirror/view";

import { updateHasEffect } from "components/organisms/manuscript/editor/visual/utils/effects";

export const languageLoadedEffect = StateEffect.define();
export const hasLanguageLoadedEffect = updateHasEffect(languageLoadedEffect);
export const setMetadataEffect = StateEffect.define();
export const setSyntaxValidationEffect = StateEffect.define();

export const metadataState = StateField.define({
    create() {
        return undefined;
    },
    update(value, transaction) {
        for (const effect of transaction.effects) {
            if (effect.is(setMetadataEffect)) {
                return effect.value;
            }
        }

        return value;
    },
});

export function languageLoadedListener(options = {}) {
    return ViewPlugin.define((view) => {
        window.setTimeout(() => {
            const effects = [languageLoadedEffect.of(null)];
            if (Object.prototype.hasOwnProperty.call(options, "syntaxValidation")) {
                effects.push(setSyntaxValidationEffect.of(Boolean(options.syntaxValidation)));
            }
            view.dispatch({ effects });
        });

        return {};
    });
}

export function setMetadata(values) {
    return {
        effects: setMetadataEffect.of(values),
    };
}

export function setSyntaxValidation(value) {
    return {
        effects: setSyntaxValidationEffect.of(Boolean(value)),
    };
}
